import { useMutate, UseMutateParams } from './useMutate';
import { useCallback } from 'react';
import { httpPatch } from '../../components/utils';

export type UsePatchParams<TData, TResponse = unknown, TError = unknown> = Omit<
    UseMutateParams<TData, TResponse, TError>,
    'method'
>;

export const usePatch = <TData, TResponse = unknown, TError = unknown>(
    params: UsePatchParams<TData, TResponse, TError>
) => {
    // @ts-ignore TODO: currently can't use the generics in `httpPut`, need to be removed when `httpPut` will support generics
    const { mutate, loading, error } = useMutate<TData, TResponse>({ ...params, method: httpPatch });

    const patch = useCallback((url: string, data?: TData) => mutate(url, data), [mutate]);

    return {
        loading,
        error,
        patch
    };
};
